import {
  GET_ACTUALS_OPTIONS_REQUEST,
  GET_ACTUALS_OPTIONS_SUCCESS,
  GET_ACTUALS_OPTIONS_ERROR,
  UPDATE_ACTUALS_OPTIONS_REQUEST,
  UPDATE_ACTUALS_OPTIONS_SUCCESS,
  UPDATE_ACTUALS_OPTIONS_ERROR,
  ACTUALS_IMPORT_STARTED,
  ACTUALS_IMPORT_COMPLETED,
  ACTUALS_IMPORT_FAILED,
  ACTUALS_IMPORT_RESET,
  FETCH_ACTUALS_IMPORT_HISTORY_REQUEST,
  FETCH_ACTUALS_IMPORT_HISTORY_SUCCESS,
  FETCH_ACTUALS_IMPORT_HISTORY_ERROR,
  FETCH_LAST_ACTUALS_IMPORT_SUCCESS,
  FETCH_PORTFOLIO_ACTUALS_REQUEST,
  FETCH_PORTFOLIO_ACTUALS_SUCCESS,
  FETCH_PORTFOLIO_ACTUALS_ERROR,
  GET_WAGE_INFLATION_REQUEST,
  GET_WAGE_INFLATION_SUCCESS,
  GET_WAGE_INFLATION_ERROR,
  UPDATE_WAGE_INFLATION_SUCCESS,
  GET_YEARLY_WAGES_REQUEST,
  GET_YEARLY_WAGES_SUCCESS,
  GET_YEARLY_WAGES_ERROR,
  BULK_SAVE_YEARLY_WAGES_REQUEST,
  BULK_SAVE_YEARLY_WAGES_SUCCESS,
  BULK_SAVE_YEARLY_WAGES_ERROR,
} from "../types";

const initialState = {
  options: null, // { laborActualsCostSource: 'COMPUTE_FROM_WAGE' | ... }
  optionsLoading: false,
  optionsError: null,

  // Per-type import phase: idle | uploading | importing | done | error
  importPhase: { LABOR: "idle", NON_LABOR: "idle" },
  importError: { LABOR: null, NON_LABOR: null },

  history: [],
  historyLoading: false,
  historyError: null,

  // Row-level imported actuals (Usage entities, type=ACTUALS).
  rows: [],
  rowsLoading: false,
  rowsError: null,

  last: { LABOR: null, NON_LABOR: null },

  // Wage governance (Actuals / Remaining Options)
  wageInflation: null, // { dorYear, enabled, years: [{ year, inflationPercent }] }
  wageInflationLoading: false,
  wageInflationError: null,

  yearlyWages: { year: null, rows: [] },
  yearlyWagesLoading: false,
  yearlyWagesError: null,
  yearlyWagesSaving: false,
};

export default function actualsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ACTUALS_OPTIONS_REQUEST:
      return { ...state, optionsLoading: true, optionsError: null };
    case GET_ACTUALS_OPTIONS_SUCCESS:
      return { ...state, optionsLoading: false, options: action.payload };
    case GET_ACTUALS_OPTIONS_ERROR:
      return { ...state, optionsLoading: false, optionsError: action.payload };

    case UPDATE_ACTUALS_OPTIONS_REQUEST:
      return { ...state, optionsLoading: true, optionsError: null };
    case UPDATE_ACTUALS_OPTIONS_SUCCESS:
      return { ...state, optionsLoading: false, options: action.payload };
    case UPDATE_ACTUALS_OPTIONS_ERROR:
      return { ...state, optionsLoading: false, optionsError: action.payload };

    case ACTUALS_IMPORT_STARTED:
      return {
        ...state,
        importPhase: { ...state.importPhase, [action.payload.type]: "importing" },
        importError: { ...state.importError, [action.payload.type]: null },
      };
    case ACTUALS_IMPORT_COMPLETED:
      return {
        ...state,
        importPhase: { ...state.importPhase, [action.payload.type]: "done" },
      };
    case ACTUALS_IMPORT_FAILED:
      return {
        ...state,
        importPhase: { ...state.importPhase, [action.payload.type]: "error" },
        importError: {
          ...state.importError,
          [action.payload.type]: action.payload.error,
        },
      };
    case ACTUALS_IMPORT_RESET:
      return {
        ...state,
        importPhase: { LABOR: "idle", NON_LABOR: "idle" },
        importError: { LABOR: null, NON_LABOR: null },
      };

    case FETCH_ACTUALS_IMPORT_HISTORY_REQUEST:
      return { ...state, historyLoading: true, historyError: null };
    case FETCH_ACTUALS_IMPORT_HISTORY_SUCCESS:
      return { ...state, historyLoading: false, history: action.payload };
    case FETCH_ACTUALS_IMPORT_HISTORY_ERROR:
      return { ...state, historyLoading: false, historyError: action.payload };

    case FETCH_PORTFOLIO_ACTUALS_REQUEST:
      return { ...state, rowsLoading: true, rowsError: null };
    case FETCH_PORTFOLIO_ACTUALS_SUCCESS:
      return { ...state, rowsLoading: false, rows: action.payload };
    case FETCH_PORTFOLIO_ACTUALS_ERROR:
      return { ...state, rowsLoading: false, rowsError: action.payload };

    case FETCH_LAST_ACTUALS_IMPORT_SUCCESS:
      return {
        ...state,
        last: { ...state.last, [action.payload.type]: action.payload.batch },
      };

    // Wage governance — inflation
    case GET_WAGE_INFLATION_REQUEST:
      return { ...state, wageInflationLoading: true, wageInflationError: null };
    case GET_WAGE_INFLATION_SUCCESS:
    case UPDATE_WAGE_INFLATION_SUCCESS:
      return {
        ...state,
        wageInflationLoading: false,
        wageInflation: action.payload,
      };
    case GET_WAGE_INFLATION_ERROR:
      return {
        ...state,
        wageInflationLoading: false,
        wageInflationError: action.payload,
      };

    // Wage governance — yearly wages grid
    case GET_YEARLY_WAGES_REQUEST:
      return { ...state, yearlyWagesLoading: true, yearlyWagesError: null };
    case GET_YEARLY_WAGES_SUCCESS:
      return {
        ...state,
        yearlyWagesLoading: false,
        yearlyWages: action.payload,
      };
    case GET_YEARLY_WAGES_ERROR:
      return {
        ...state,
        yearlyWagesLoading: false,
        yearlyWagesError: action.payload,
      };
    case BULK_SAVE_YEARLY_WAGES_REQUEST:
      return { ...state, yearlyWagesSaving: true, yearlyWagesError: null };
    case BULK_SAVE_YEARLY_WAGES_SUCCESS:
      return {
        ...state,
        yearlyWagesSaving: false,
        yearlyWages: action.payload,
      };
    case BULK_SAVE_YEARLY_WAGES_ERROR:
      return {
        ...state,
        yearlyWagesSaving: false,
        yearlyWagesError: action.payload,
      };

    default:
      return state;
  }
}
